export * from './typeUtils';
export * from './aimStatusUtils';
export * from './arrayUtils';
export * from './dateUtils';
export * from './formUtils';
export * from './errorUtils';
export * from './fileUtils';
export * from './numberUtils';
export * from './stringUtils';
export * from './groupArray';
export * from './opportunityUtils';
export * from './approvalFilters';
export * from './approvalUtils';
export * from './PriorityUtils';
export * from './transactionTeamUtils';
export * from './authUtils';
export { AppRoles, type AppRoleName } from './generated/appRoles.generated';
export { AppPermissions, type AppPermissionKey } from './generated/appPermissions.generated';
import { AppPermissions as _AppPermissions } from './generated/appPermissions.generated';
import { AppRoles as _AppRoles } from './generated/appRoles.generated';

/** Set of permission keys present in the generated AppPermissions const — i.e. referenced in code. */
export const codedPermissionKeys: ReadonlySet<string> = new Set(
  Object.values(_AppPermissions).flatMap(app => Object.values(app))
);

/** Set of role names present in the generated AppRoles const — i.e. referenced in code. */
export const codedRoleNames: ReadonlySet<string> = new Set(
  Object.values(_AppRoles).flatMap(app => Object.values(app))
);

/** Reverse map: permission key string (e.g. 'Admin.Manage') → JS path (e.g. 'AppPermissions.prism.adminManage') */
export const permissionKeyToJsPath: ReadonlyMap<string, string> = new Map(
  Object.entries(_AppPermissions).flatMap(([appCamel, perms]) =>
    Object.entries(perms).map(([permCamel, key]) => [key, `AppPermissions.${appCamel}.${permCamel}`] as const)
  )
);

/** Reverse map: permission key string → app camelCase group key (e.g. 'Admin.Manage' → 'prism') */
export const permissionKeyToAppGroup: ReadonlyMap<string, string> = new Map(
  Object.entries(_AppPermissions).flatMap(([appCamel, perms]) =>
    Object.values(perms).map(key => [key, appCamel] as const)
  )
);

/** Reverse map: role name string (e.g. 'Prism.Admin') → JS path (e.g. 'AppRoles.prism.admin') */
export const roleNameToJsPath: ReadonlyMap<string, string> = new Map(
  Object.entries(_AppRoles).flatMap(([appCamel, roles]) =>
    Object.entries(roles).map(([roleCamel, key]) => [key, `AppRoles.${appCamel}.${roleCamel}`] as const)
  )
);
export * from './getModuleQuery';
export { useAsyncEffect } from './hooks/useAsyncEffect';
export { default as useLocalStorageState } from './hooks/useLocalStorageState';
export { useDeviceDetection, DeviceType } from './hooks/useDeviceDetection';
export { useCurrentUser } from './hooks/useCurrentUser'
export { useDeviceOrientation } from './hooks/useDeviceOrientation';
export { useMobileBreakpoint, MOBILE_BREAKPOINT } from './hooks/useMobileBreakpoint';
export { default as useAgMutation } from './hooks/useAgMutation';
export { default as useAgLazyQuery } from './hooks/useAgLazyQuery';
export { default as useDebounceEffect } from './hooks/useDebounceEffect';
export { useBackwardNav } from './hooks/useBackwardNav';
export { default as errorResponse } from './errorResponse';
export * from './validationErrors';
export * from './hooks/indexDb/useIndexDb';
export * from './hooks/indexDb/useIndexDbTable';
export * from './hooks/indexDb/useIndexDbTableSelector';
export * from './hooks/indexDb/IndexDb';
export * from './hooks/useUploadFile';
export * from './hooks/useEmployees';
export * from './hooks/useChecklistMilestones';
export { default as errorBoundaryWrapper } from './errorBoundaryWrapper';
export { useNotes } from './hooks/useNotes';
export { default as useAimStatus } from './hooks/useAimStatus';
export * from './aimConstants';
export * from './PriceUtils';
export * from './areaUnitUtils';
export { useUserPhotoByName } from './hooks/useUserPhotoByName';
